import { LocaleInput } from '../index.js'

export default {
  code: 'he',
  direction: 'rtl',
  buttonText: {
    prev: 'הקודם',
    next: 'הבא',
    today: 'היום',
    month: 'חודש',
    week: 'שבוע',
    day: 'יום',
    list: 'סדר יום',
  },
  allDayText: 'כל היום',
  moreLinkText: 'אחר',
  noEventsText: 'אין אירועים להצגה',
  weekText: 'שבוע',
} as LocaleInput
